import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {
  Link,
  Text,
  Checkbox
} from '@comicrelief/component-library';
import { FIELDS } from '../constants';
import { TermsConditionsWrapper } from '../FundraiserSignup.style';

const StyledLink = styled(Link)`
  &,
  :hover,
  :focus {
    color: ${({ theme, currentColour }) => theme.color(currentColour)};
  }

  font-weight: ${({ isErroring }) => (isErroring ? 'bold' : 'normal')};
`;

const LongLabel = ({ isErroring }) => {
  const textColour = isErroring ? 'red' : 'black';

  return (
    <Text
      tag="p"
      color={textColour}
      weight={isErroring ? 'bold' : 'normal'}
    >
      I confirm I am over 18 and agree to Comic Relief&apos;s
      {' '}
      <StyledLink
        target="blank"
        href="/terms-of-use/"
        currentColour={textColour}
        isErroring={isErroring}
      >
        Terms of Use
      </StyledLink>
      {' '}
      including the Fundraising
      {' '}
      <StyledLink
        target="blank"
        href="/terms-of-use#fundraising-dos-and-donts-anchor"
        currentColour={textColour}
        isErroring={isErroring}
      >
        Dos & Don&apos;ts
      </StyledLink>
      .
      For further information on how Comic Relief will use your information please read our
      {' '}
      <StyledLink
        target="blank"
        href="/privacy-notice/"
        currentColour={textColour}
        isErroring={isErroring}
      >
        Privacy Policy
      </StyledLink>
      .
    </Text>
  );
};

LongLabel.propTypes = {
  isErroring: PropTypes.bool.isRequired
};

const TermsAndConditions = ({ register, currentError }) => {
  const isErroring = Boolean(currentError);
  const textColour = isErroring ? 'red' : 'black';

  return (
    <TermsConditionsWrapper>
      <Checkbox
        {...register(FIELDS.OVER_EIGHTEEN)}
        name={FIELDS.OVER_EIGHTEEN}
        value="true"
        id={FIELDS.OVER_EIGHTEEN}
        data-test="fsu-over-18"
        checkboxBorder={textColour}
      >
        <LongLabel isErroring={isErroring} />
      </Checkbox>
    </TermsConditionsWrapper>
  );
};

export default TermsAndConditions;

TermsAndConditions.propTypes = {
  register: PropTypes.func.isRequired,
  currentError: PropTypes.string
};
